import { ajax } from '../../../services/helper'
class ApiService {

    getPlatformsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addPlatforms = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getPlatformsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editPlatforms = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Platforms/services/apiservices.js